//  * @package         src/components/Dashboard
//  * @author          Riddhi D Parekh
//  * @date            02nd October 2018
//  * @type            Center Questions Component File
//  * @description -   This file renders the html and functionality for center component when questions tab is choosed.
<template>
   <div class="col-md-12 p-0 col-xs-12 survey_colume_2 heightcal">
      <div class="skiplogic-content colume_2_question sticky_bar">
         <div :class="!isFullScreen ? 'tabs-wrapper margin77' : 'tabs-wrapper'">
            <div class="pan-wrap-new" v-if="!isFullScreen">
               <div class="pannel-icons-new">
                  <ul>
                     <li>
                        <a
                           href="#"
                           data-toggle="tooltip"
                           data-placement="top"
                           title="Online Form"
                           :class="all.in_survey_type == 1 || all.in_survey_type == 3 ? '' : 'disabled-icon'"
                           >
                        <i class="fa fa-globe" aria-hidden="true"></i>
                        </a>
                     </li>
                     <li>
                        <a
                           href="#"
                           data-toggle="tooltip"
                           data-placement="top"
                           title="Mobile Form"
                           :class="all.in_survey_type == 2 || all.in_survey_type == 3 ? '' : 'disabled-icon'"
                           >
                        <i class="fa fa-mobile icon-mobile-fn-size" aria-hidden="true"></i>
                        </a>
                     </li>
                     <li>
                        <a
                           href="#"
                           data-toggle="tooltip"
                           data-placement="top"
                           :title="all.in_question_flow == 0 ? 'One At A Time' : 'All In One'"
                           >
                        <i
                           :class="all.in_question_flow == 0 ? 'fa fa-long-arrow-down' : 'fa fa-sort-alpha-asc'"
                           aria-hidden="true"
                           ></i>
                        </a>
                     </li>
                     <li>
                        <a
                           href="#"
                           data-toggle="tooltip"
                           data-placement="top"
                           title="Audit Form"
                           :class="all.in_audit ? '' : 'disabled-icon'"
                           >
                           <!--<img src="../../assets/images/edit-icon-1.png" alt="edit-icon" class="img-responsive">-->
                           <i class="fa fa-tachometer"></i>
                        </a>
                     </li>
                     <li>
                        <a
                           href="#"
                           data-toggle="tooltip"
                           data-placement="top"
                           title="Loop Form"
                           :class="all.in_loop_survey ? '' : 'disabled-icon'"
                           >
                        <i class="fa fa-refresh" aria-hidden="true"></i>
                        </a>
                     </li>
                  </ul>
               </div>
               <ul class="nav nav-tabs" role="tablist">
                  <li class="nav-item">
                     <a class="nav-link" data-toggle="tab" href="#" @click="updateSkipLogic">
                     <!-- <span class="email-new-wrap t-length icon-edit" v-if="currentQno > -1 && questionLists[parseInt(currentQno)]">
                     <i
                        :class="questionLists[parseInt(currentQno)]['st_class_name'] ? questionLists[parseInt(currentQno)]['st_class_name'] : questionLists[parseInt(currentQno)]['question_type_details']['control_details']['st_class_name']"
                        aria-hidden="true"
                        ></i>
                     </span>
                     <span class="email-new-wrap t-length icon-edit" v-else>
                     <i
                        :class="currentQno == -2 ? 'fa fa-play-circle-o' : 'fa fa-stop-circle-o'"
                        aria-hidden="true"
                        ></i>
                     </span> -->
                     <span v-if="parseInt(currentQno)+1 > 0">Question {{parseInt(currentQno)+1}}</span>
                     <span v-else-if="parseInt(currentQno)+1 == -1">Start Screen</span>
                     <span v-else>End Screen</span>
                     </a>
                  </li>
                  <li class="nav-item">
                     <a class="nav-link active" data-toggle="tab" href="#skip-section">Skip logic</a>
                  </li>
               </ul>
            </div>
            <!-- Tab panes -->
            <div class="tab-content">
                <span :class="isFullScreen ? 'icomoon-minimize full-view-wrap':'icomoon-fullscreenview full-view-wrap'" @click="callSetFullScreenMode(!isFullScreen)">
                  </span>
               <div id="skip-section" class="container tab-pane active">
                  <!-- Start screen code -->
                  <div v-if="questionStartEnd.start && startActivate === 1" class="skip-logic-start row">
                     <div
                        class="question_colume"
                        :id="'que_'+questionStartEnd['start']['in_question_master_id']"
                        :data-que-id="questionStartEnd['start']['in_question_master_id']"
                        :data-que-type-id="questionStartEnd['start']['in_question_type_id']"
                        :data-id="questionStartEnd['start']['question_type_details'] ? questionStartEnd['start']['question_type_details']['in_control_id'] : ''"
                        :data-controlName="'Start screen'"
                        :data-className="'fa fa-play-circle-o'"
                        >
                        <div class="panel-group" id="accordion">
                           <div class="panel panel-default center_data_lop">
                              <div class="panel-heading">
                                 <span class="width40">0</span>
                                 <h4 class="panel-title">
                                    <i class="fa fa-play-circle-o activeStartEndScreen" aria-hidden="true"></i>
                                    <a href="#">Start Screen</a>
                                 </h4>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div
                     class="question_colume"
                     :style="questionLists.length == 0 ? '' : 'margin-bottom: 1px;'"
                     >
                     <div class="panel-group icon-edit">
                        <!-- <h4 v-for="(questionList, index) in questionLists"></h4> -->
                        <!-- <div > -->
                        <!-- {{setQuestionTitle}} -->
                        <emptyquestion
                           v-for="(questionList, index) in questionLists"
                           :key="questionList['in_question_master_id'] ? questionList['in_question_master_id'] : questionList['dbQueId']"
                           :cid="questionList['in_control_id'] ? questionList['in_control_id'] : questionList['question_type_details']['in_control_id']"
                           :qid="index+1"
                           :controlName="questionList['st_control_name'] ? questionList['st_control_name'] : questionList['question_type_details']['control_details']['st_control_name']"
                           :dbQid="questionList"
                           :questionNo="questionLists.length === index+1 ? index+1+' last' : index+1"
                           :questionNoClass="questionLists.length > 99 ? 'width40px' : 'width30px'"
                           :className="questionList['st_class_name'] ? questionList['st_class_name'] : questionList['question_type_details']['control_details']['st_class_name']"
                           :questionName="questionList['st_question_title'] ? questionList['st_question_title'] : questionList['st_control_name'] + ' Question'"
                           :isRequired="questionList['question_validation_details'] ? (questionList['question_validation_details'][0] ? (questionList['question_validation_details'][0]['question_answer_details'] ? (questionList['question_validation_details'][0]['question_answer_details'][0] ? questionList['question_validation_details'][0]['question_answer_details'][0]['st_answer_text'] : 0) : 0): 0) : 0 "
                           :dbQTypeId="questionList['in_question_type_id']"
                           @click.native="showRuleModal($event, index)"
                           ></emptyquestion>
                        <!-- </div> -->
                     </div>
                     <div>
                        <b-modal
                           id="skipLogicModal"
                           ref="skipLogicModal"
                           size="xl"
                           title="Skip Logic"
                           no-enforce-focus
                           hide-footer
                           @close="hideSkipModal"
                           :dialog-class="[{'show-overlay': isTouched}]"
                           >
                           <div slot="modal-title">
                              Skip Logic
                              <i class="skipqtitle">({{questionTitle}})</i>
                           </div>
                           <div class="modal-body-content">
                              <form @submit.stop.prevent="handleSubmit">
                                 <h6>Select Question:</h6>
                                 <multi-select
                                    name="selectedQuestion"
                                    track-by="in_question_master_id"
                                    :disabled="(skipRules[0] && !skipRules[0].isRuleNotAdded) || !isAddModal"
                                    label="st_question_title"
                                    deselect-label="Can't remove this value"
                                    :allow-empty="false"
                                    :options="skipQuePrevArray"
                                    v-model="skipSelectedQue[0]"
                                    @input="fillSkipAnswers"
                                    v-validate="'required'"
                                    data-vv-as="above"
                                    data-vv-validate-on="select"
                                    @open="isTouched = true"
                                    @close="isTouched = false"
                                    ></multi-select>
                                 <span
                                    class="error"
                                    v-if="errors.has('selectedQuestion')"
                                    >{{ errors.first('selectedQuestion') }}</span>
                                 <b-card
                                    v-for="(rule,i) in skipRules"
                                    :key="i"
                                    header-tag="header"
                                    class="form-group"
                                    >

                                    <div slot="header" class="mb-0">
                                       <div class="row">
                                          <div class="same-rules">
                                             <h6>Rule {{notAnsNoAnsQue ? parseInt(i)+1 : ''}}</h6>
                                             <div class="question-wrap-new">
                                                <ul class="col-md-6 question_select margin-bottom-zero">
                                                   <li>
                                                      <input
                                                         :id="'answered'+i"
                                                         :value="false"
                                                         :key="'ans'+i"
                                                         :name="'type_ans'+i"
                                                         v-model="ruleAnsNoAns[i]"
                                                         :disabled="!rule.isRuleNotAdded"
                                                         type="radio"
                                                         >
                                                      <label :for="'answered'+i">Answered</label>
                                                   </li>
                                                   <li>
                                                      <input
                                                         :id="'notanswered'+i"
                                                         :key="'noans'+i"
                                                         :value="true"
                                                         :name="'type_ans'+i"
                                                         v-model="ruleAnsNoAns[i]"
                                                         :disabled="!rule.isRuleNotAdded"
                                                         type="radio"
                                                         >
                                                      <label :for="'notanswered'+i">Not Answered</label>
                                                   </li>
                                                </ul>    
                                                {{ /* rule.skipCondition + '----'+ disableAndCondition */ }}                                            
                                                <ul
                                                   v-if="i>0 && notAnsNoAnsQue"
                                                   class="col-md-2 question_select margin-bottom-zero"
                                                   >   
                                                   <li v-if="!ruleAnsNoAns[i-1] && isMultipleAnsAllowed && !disableAndCondition && rule.skipCondition !== 'EQUALS'">
                                                      <input
                                                         :id="'conditionand'+i"
                                                         :value="false"
                                                         :name="'rules_condition'+i"
                                                         :disabled="!rule.isRuleNotAdded"
                                                         v-model="ruleConditions[i-1]"
                                                         type="radio"
                                                         >
                                                      <label :for="'conditionand'+i">And</label>
                                                   </li>
                                                   <li>
                                                      <input
                                                         :id="'conditionor'+i"
                                                         :value="true"
                                                         :name="'rules_condition'+i"
                                                         :disabled="!rule.isRuleNotAdded"
                                                         v-model="ruleConditions[i-1]"
                                                         type="radio"
                                                         >
                                                      <label :for="'conditionor'+i">Or</label>
                                                   </li>
                                                </ul>
                                                <span
                                                   v-if="!rule.isRuleNotAdded && skipRules.length > 1 && notAnsNoAnsQue"
                                                   @click="removeRuleFromArray(i)"
                                                   class="trash-right text-right"
                                                   >
                                                <i class="fa fa-trash"></i>
                                                </span>
                                             </div>
                                          </div>
                                       </div>
                                    </div>

                                    <div
                                       class="row survey_settings form-group"
                                       v-if="rule.isRuleNotAdded && !ruleAnsNoAns[i] && notAnsNoAnsQue"
                                       >
                                       <div class="col-md-6">
                                          <h6 class="edit_head">Condition</h6>
                                          <div>
                                             <div class="condition-wraps">
                                                <span class="skip-cndtn">Equals</span>
                                                <div class="answer_btn">
                                                   <label class="switch">
                                                   <input
                                                      :name="'rule_condition'+i"
                                                      value="EQUALS"
                                                      v-model="rule.skipCondition"
                                                      type="radio"
                                                      >
                                                   <span class="slider round"></span>
                                                   </label>
                                                </div>
                                             </div>
                                             <div>
                                                <div class="condition-wraps">
                                                   <span class="skip-cndtn">Contains</span>
                                                   <div class="answer_btn">
                                                      <label class="switch">
                                                      <input
                                                         v-model="rule.skipCondition"
                                                         value="CONTAINS"
                                                         :name="'rule_condition'+i"
                                                         type="radio"
                                                         >
                                                      <span class="slider round"></span>
                                                      </label>
                                                   </div>
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                       <div class="col-md-6">
                                          <h6 class="edit_head">Inclusion</h6>
                                          <div>
                                             <div class="condition-wraps" v-if="isMultipleAnsAllowed">
                                                <span class="skip-cndtn">All</span>
                                                <div class="answer_btn">
                                                   <label class="switch">
                                                   <input
                                                      v-model="rule.skipInclusion"
                                                      value="ALL"
                                                      :name="'inclusion_value'+i"
                                                      type="radio"
                                                      >
                                                   <span class="slider round"></span>
                                                   </label>
                                                </div>
                                             </div>
                                             <div>
                                                <div class="condition-wraps">
                                                   <span class="skip-cndtn">Any</span>
                                                   <div class="answer_btn">
                                                      <label class="switch">
                                                      <input
                                                         v-model="rule.skipInclusion"
                                                         value="ANY"
                                                         :name="'inclusion_value'+i"
                                                         type="radio"
                                                         >
                                                      <span class="slider round"></span>
                                                      </label>
                                                   </div>
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                    <!-- For answers option -->
                                    <div
                                       class="form-group"
                                       v-if="rule.isRuleNotAdded && !ruleAnsNoAns[i] && notAnsNoAnsQue"
                                       >
                                       <multi-select
                                          v-if="skipAnsArray[0] && (typeof skipAnsArray[0] === 'string' || typeof skipAnsArray[0] === 'number') && !isQuestionTypeFace && !isQuestionTypeStar"
                                          :disabled="ruleAnsNoAns[i]"
                                          name="selectedAnswer"
                                          :multiple="true"
                                          deselect-label="Can't remove this value"
                                          :options="skipAnsArray"
                                          v-model="skipSelectedAns[i]"
                                          v-validate="'required'"
                                          data-vv-as="above"
                                          data-vv-validate-on="select"
                                          @open="isTouched = true"
                                          @close="isTouched = false"
                                          ></multi-select>
                                       <!-- For multiple choice image -->
                                       <multi-select
                                          v-else-if="skipAnsArray[0] && typeof skipAnsArray[0] === 'object' && !isQuestionTypeFace && !isQuestionTypeStar"
                                          :disabled="ruleAnsNoAns[i]"
                                          v-model="skipSelectedAns[i]"
                                          label="img_label"
                                          name="selectedAnswer"
                                          :multiple="true"
                                          :show-labels="false"
                                          track-by="img_path"
                                          :options="skipAnsArray"
                                          :option-height="104"
                                          class="multi-image-dropdown"
                                          v-validate="'required'"
                                          data-vv-as="above"
                                          data-vv-validate-on="select"
                                          @open="isTouched = true"
                                          @close="isTouched = false"
                                          >
                                          <template slot="tag" slot-scope="props">
                                             <div class="main-wrap-select">
                                                <div class="img-main">
                                                   <v-lazy-image :src="props.option.img_url"></v-lazy-image>
                                                </div>
                                                <span class="option__desc">
                                                <span class="option__title">{{ props.option.img_label }}</span>
                                                </span>
                                                <i
                                                   :id="props.option.img_id"
                                                   aria-hidden="true"
                                                   tabindex="1"
                                                   class="multiselect__tag-icon"
                                                   @click="removeOptionFromSelect(i,$event)"
                                                   ></i>
                                                <!-- <i
                                                   :id="props.option.img_id"
                                                   aria-hidden="true"
                                                   tabindex="1"
                                                   class="multiselect__tag-icon"
                                                   
                                                       ></i>-->
                                             </div>
                                          </template>
                                          <template slot="option" slot-scope="props">
                                             <div class="img-wrap-new">
                                                <v-lazy-image class="option__image" :src="props.option.img_url"></v-lazy-image>
                                             </div>
                                             <div class="option__desc">
                                                <span class="option__title">{{ props.option.img_label }}</span>
                                             </div>
                                          </template>
                                       </multi-select>
                                       <!-- for face rating -->
                                       <multi-select
                                          v-else-if="isQuestionTypeFace"
                                          :disabled="ruleAnsNoAns[i]"
                                          name="selectedAnswer"
                                          :multiple="true"
                                          deselect-label="Can't remove this value"
                                          :options="skipAnsArray"
                                          v-model="skipSelectedAns[i]"
                                          v-validate="'required'"
                                          data-vv-as="above"
                                          data-vv-validate-on="select"
                                          class="multi-face-dropdown"
                                          @open="isTouched = true"
                                          @close="isTouched = false"
                                          >
                                          <template slot="tag" slot-scope="props">
                                             <div class="multiselect__tags-custom">
                                                <i
                                                   :id="props.option"
                                                   aria-hidden="true"
                                                   tabindex="1"
                                                   class="multiselect__tag-icon"
                                                   @click="removeOptionFromSelect(i,$event)"
                                                   ></i>
                                                <span class="modal-label ck-span">
                                                <i :class="smileyClass[props.option]"></i>
                                                </span>
                                             </div>
                                          </template>
                                          <template slot="option" slot-scope="props">
                                             <span class="modal-label ck-span">
                                             <i :class="smileyClass[props.option]"></i>
                                             </span>
                                          </template>
                                       </multi-select>
                                       <!-- for star rating -->
                                       <multi-select
                                          v-else-if="isQuestionTypeStar"
                                          :disabled="ruleAnsNoAns[i]"
                                          name="selectedAnswer"
                                          :multiple="true"
                                          deselect-label="Can't remove this value"
                                          :options="skipAnsArray"
                                          v-model="skipSelectedAns[i]"
                                          v-validate="'required'"
                                          data-vv-as="above"
                                          data-vv-validate-on="select"
                                          class="multi-face-dropdown"
                                          @open="isTouched = true"
                                          @close="isTouched = false"
                                          >
                                          <template slot="tag" slot-scope="props">
                                             <div class="multiselect__tags-custom">
                                                <i
                                                   :id="'star'+props.option"
                                                   aria-hidden="true"
                                                   tabindex="1"
                                                   class="multiselect__tag-icon"
                                                   @click="removeOptionFromSelect(i,$event)"
                                                   ></i>
                                                <span class="skiplogic rating">
                                                <span class="icon" v-for="j in parseInt(props.option)" :key="j">★</span>
                                                </span>
                                             </div>
                                          </template>
                                          <template slot="option" slot-scope="props">
                                             <span class="skiplogic rating">
                                             <span class="icon" v-for="j in parseInt(props.option)" :key="j">★</span>
                                             </span>
                                          </template>
                                       </multi-select>
                                       <span
                                          class="error"
                                          v-if="errors.has('selectedAnswer')"
                                          >{{ errors.first('selectedAnswer') }}</span>
                                    </div>
                                    <!-- Add button -->
                                    <div class="form-group" v-if="rule.isRuleNotAdded && notAnsNoAnsQue">
                                       <div class="end_save_btn save_cancel paddingB0" v-if="isAddModal">
                                          <a class="btn-whitelable"
                                             href="#"
                                             @click="addRuleToArray(i)"
                                             style="cursor:pointer;"
                                             name="addRule"
                                             id="btnAddRule"
                                             >
                                          <span>Add</span>
                                          </a>
                                       </div>
                                       <div
                                          class="end_save_btn save_cancel paddingB0 save_cancel_remove"
                                          v-if="skipRules.length > 1"
                                          >
                                          <a class="btn-cancel"
                                             href="#"
                                             name="removeRule"
                                             @click="removeRuleFromArray(i)"
                                             id="btnRemoveRule"
                                             >
                                          <span>Remove</span>
                                          </a>
                                       </div>
                                    </div>
                                    <div
                                       v-if="!rule.isRuleNotAdded && !ruleAnsNoAns[i]"
                                       class="form-group form-group-new"
                                       >
                                       <span
                                          class="display-skip-info equal-block"
                                          >{{ rule.skipCondition == 'EQUALS' ? '=' : rule.skipCondition == 'CONTAINS' ? '<' : 'NA'}}</span>
                                       <span
                                          class="display-skip-info skip-new-two"
                                          >{{ rule.skipInclusion === 'ALL' ? 'ALL' : 'ANY'}}</span>
                                       <div
                                          class="skip-data"
                                          v-if="skipSelectedQue[0]['in_question_type_id'] === vueQueTypeConfig.TYPE_MULTIPLE_IMAGE"
                                          >
                                          <span
                                             class="display-skip-info img-block"
                                             v-for="(ans,k) in skipSelectedAns[i]"
                                             :key="k"
                                             >
                                             <v-lazy-image :src="ans.img_url"></v-lazy-image>
                                          </span>
                                       </div>
                                       <div
                                          class="skip-data"
                                          v-else-if="skipSelectedQue[0]['in_question_type_id'] === vueQueTypeConfig.TYPE_SATISFACTION"
                                          >
                                          <span
                                             class="display-skip-info modal-label ck-span"
                                             v-for="(ans,k) in skipSelectedAns[i]"
                                             :key="k"
                                             >
                                          <i :class="smileyClass[ans]"></i>
                                          </span>
                                       </div>
                                       <div v-else class="form-group form-group-new">
                                          <span
                                             class="display-skip-info skip-data"
                                             v-for="(ans,k) in skipSelectedAns[i]"
                                             :key="k"
                                             >{{ ans }}</span>
                                       </div>
                                    </div>
                                 </b-card>
                                 <div
                                    class="form-group add-panel"
                                    v-if="(skipRules[skipRules.length - 1] && !skipRules[skipRules.length - 1].isRuleNotAdded) || !isAddModal && notAnsNoAnsQue"
                                    >
                                    <span>
                                    <i @click="addNewRule" class="fa fa-2x fa-plus-circle"></i>
                                    </span>
                                 </div>
                                 <!-- If block -->
                                 <b-card header-tag="header" class="form-group">
                                    <div slot="header" class="mb-0">
                                       <div class="row">
                                          <div class="same-rules">
                                             <h6>Jump</h6>
                                          </div>
                                       </div>
                                    </div>
                                    <div class="form-group">
                                       <h6>Then question</h6>
                                       <multi-select
                                          name="selectedIfQuestion"
                                          track-by="in_question_master_id"
                                          label="st_question_title"
                                          deselect-label="Can't remove this value"
                                          :allow-empty="false"
                                          :options="skipQueNextArray"
                                          v-model="skipIfSelectedQue"
                                          v-validate="'required|checkSameIfJumpQ'"
                                          data-vv-as="above"
                                          data-vv-validate-on="select"
                                          @open="isTouched = true"
                                          @close="isTouched = false"
                                          ></multi-select>
                                       <span
                                          class="error"
                                          v-if="errors.has('selectedIfQuestion')"
                                          >{{ errors.first('selectedIfQuestion') }}</span>
                                    </div>
                                    <!-- Else block -->
                                    <div class="form-group">
                                       <h6>Else question</h6>
                                       <multi-select
                                          name="selectedElseQuestion"
                                          track-by="in_question_master_id"
                                          label="st_question_title"
                                          deselect-label="Can't remove this value"
                                          :allow-empty="false"
                                          :options="skipQueNextArray"
                                          v-model="skipElseSelectedQue"
                                          v-validate="'required|checkIfElseQ|checkSameElseJumpQ'"
                                          data-vv-as="above"
                                          data-vv-validate-on="select"
                                          @open="isTouched = true"
                                          @close="isTouched = false"
                                          ></multi-select>
                                       <span
                                          class="error"
                                          v-if="errors.has('selectedElseQuestion')"
                                          >{{ errors.first('selectedElseQuestion') }}</span>
                                    </div>
                                    <span
                                      class="error"
                                      v-if="identicalRules"
                                      >Identical rules cannot be created.</span>
                                      <span
                                      class="error"
                                      v-if="multipleAnsNotAllowedEqual"
                                      >You cannot go EQUAL condition with AND OPERATOR in same skip logic.</span>
                                 </b-card>
                              </form>
                           </div>
                           <div class="survey_settings row">
                              <div class="col-md-12">
                                 <div class="end_save_btn save_cancel">
                                    <a class="btn-cancel" href="#" @click.prevent="hideSkipModal">cancel</a>
                                    <a class="btn-whitelable" href="#" @click.prevent="addRule">
                                    <span>Save</span>
                                    </a>
                                 </div>
                              </div>
                           </div>
                        </b-modal>
                     </div>
                  </div>
                  <div v-if="questionStartEnd.end && endActivate === 1">
                     <div
                        class="question_colume center_data_lop"
                        :id="'que_'+questionStartEnd['end']['in_question_master_id']"
                        :data-que-id="questionStartEnd['end']['in_question_master_id']"
                        :data-que-type-id="questionStartEnd['end']['in_question_type_id']"
                        :data-id="questionStartEnd['end']['question_type_details'] ? questionStartEnd['end']['question_type_details']['in_control_id']:''"
                        :data-controlName="'End screen'"
                        :data-className="'fa fa-stop-circle-o'"
                        >
                        <div class="panel-group">
                           <div class="end panel panel-default mtop50custom">
                              <div class="panel-heading">
                                 <span class="width40">{{questionLists.length + 1}}</span>
                                 <h4 class="panel-title">
                                    <i class="fa fa-stop-circle-o activeStartEndScreen" aria-hidden="true"></i>
                                    <a href="#" data-toggle="collapse" data-parent="#accordion">End Screen</a>
                                 </h4>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div v-else>
                     <div
                        class="question_colume center_data_lop"
                        :id="'que_-99'"
                        data-que-id="-99"
                        data-que-type-id="25"
                        data-id="q18"
                        :data-controlName="'End form'"
                        :data-className="'fa fa-stop-circle-o'"
                        >
                        <div class="panel-group">
                           <div class="end panel panel-default mtop50custom">
                              <div class="panel-heading">
                                 <h4 class="panel-title">
                                    <i class="fa fa-stop-circle-o" aria-hidden="true"></i>
                                    <a href="#" data-toggle="collapse" data-parent="#accordion">End Form</a>
                                 </h4>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <back-to-top visibleoffset="300" bottom="50px" right="50px">
                  <button type="button" class="btn btn-info btn-to-top">
                  <i class="fa fa-chevron-up"></i>
                  </button>
               </back-to-top>
            </div>
         </div>
      </div>
   </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { EventBus } from "../../main";
import draggable from "vuedraggable";
import emptyquestion from "./emptyquestion";
var other_image = require("../../assets/images/other_image.png");

var {
  queTypeConfig,
  queValidationConfig,
  queControlConfig,
  constantCommonConfig,
  constantUserPermissions
} = require("../../../config/config.js");

export default {
  name: "skipLogic",
  components: {
    draggable,
    emptyquestion
  },
  data() {
    return {
      vueQueTypeConfig: queTypeConfig,
      startActivate: 1,
      endActivate: 1,
      questionLists: [],
      questionStartEnd: {},
      connectionsData: {},
      skipDataArray: [],
      skipAnsArray: [],
      skipQueNextArray: [],
      skipQuePrevArray: [],

      skipSelectedAns: [],
      skipSelectedQue: [],
      ruleConditions: [],
      ruleAnsNoAns: [false],
      skipRules: [
        {
          skipCondition: "EQUALS",
          skipInclusion: "ALL",
          isRuleNotAdded: true
        }
      ],
      skipIfSelectedQue: [],
      skipElseSelectedQue: [],
      questionTitle: "",
      // skipDataRetrieved: false,
      isMultipleAnsAllowed: false, 
      isQuestionTypeFace: false,
      isQuestionTypeStar: false,
      smileyClass: {
        ":)": "em em-smile",
        ":|": "em em-neutral_face",
        ":P": "em em-heart_eyes",
        ":@": "em em-angry",
        ":(": "em em-disappointed"
      },
      isAddModal: true,
      editRuleId: "",
      notAnsNoAnsQue: true,
      disableAndCondition: false,
      linesInstance: [],
      identicalRules:false,
      multipleAnsNotAllowedEqual:false,
      isTouched: false,
      canEditRule: this.$session.get("user_permissions")
                    ? (this.$session.get("user_permissions")[constantUserPermissions.EDIT_SKIP_LOGIC_RULE] ? 1 : 0 )
                    : 0,
    };
  },
  computed: {
    // for icons above start screen
    ...mapGetters("LeftSidebarCreate", ["all", "surveytypes"]),
    ...mapGetters("editquestionEdit", ["surveyQuestions"]),
    ...mapGetters("editquestionEdit", {
      surveyStartEndQuest: "surveyStartEndQuestions",
      surveyQuestionWithDetails: "getSurveyQuestWithDetails",
      getSkipLogicDetails: "getSkipLogicDetails",
      currentQno: "currentQno",
      isFullScreen: "isFullScreen",
      ruleCreatedIds: "ruleCreatedIds"
    })
  },
  async created() {
    console.log('in created')
    this.skipDataArray = this.$session.getAll();
    this.skipDataArray["in_survey_Id"] = this.$route.params.id;
    delete this.skipDataArray["propertyname"];
    delete this.skipDataArray["session-id"];
    document.body.classList.add("skip-logic-section");
    // this.questionLists = this.$store.getters[
    //   "editquestionEdit/surveyQuestions"
    // ];
    this.questionLists = this.surveyQuestions;
    this.questionStartEnd = this.surveyStartEndQuest;
    this.startActivate = this.questionStartEnd["start"]
      ? this.questionStartEnd["start"]["in_status"]
      : "";
    this.endActivate = this.questionStartEnd["end"]
      ? this.questionStartEnd["end"]["in_status"]
      : "";

    // if (!this.skipLogicRetrieved) {
    //   await this.getSkipLogicRules(this.skipDataArray).then(value => {
    //     this.skipDataRetrieved = true;
    //     setTimeout(() => {
    //       this.updateConnectionsArray();
    //     }, 500);
    //   });
    // } else {
    //   this.skipDataRetrieved = true;
    //   setTimeout(() => {
    //     this.updateConnectionsArray();
    //   }, 200);
    // }
  },
  async mounted() {
    this.updateConnectionsArray();
    // Custom validation for if else question match
    this.$validator.extend("checkIfElseQ", {
      getMessage: field => "If else question selection should be unique.",
      validate: value => {
        if (
          this.skipIfSelectedQue.in_question_master_id &&
          this.skipElseSelectedQue.in_question_master_id &&
          this.skipIfSelectedQue.in_question_master_id ===
            this.skipElseSelectedQue.in_question_master_id
        )
          return false;
        else return true;
      }
    });
    // Custom validation to check if rule is created and jumped to if are on same question
    this.$validator.extend("checkSameIfJumpQ", {
      getMessage: field => "Question cannot jump on same question.",
      validate: value => {
        console.log('being check')
        console.log(this.skipSelectedQue[0].in_question_master_id)
        if (
          this.skipIfSelectedQue.in_question_master_id &&
          (this.skipIfSelectedQue.in_question_master_id ===
            this.skipSelectedQue[0].in_question_master_id)
        )
          return false;
        else return true;
      }
    });
    // Custom validation to check if rule is created and jumped to else are on same question
    this.$validator.extend("checkSameElseJumpQ", {
      getMessage: field => "Question cannot jump on same question.",
      validate: value => {
        if (
          this.skipElseSelectedQue.in_question_master_id &&
          (this.skipElseSelectedQue.in_question_master_id ===
            this.skipSelectedQue[0].in_question_master_id)
        )
          return false;
        else return true;
      }
    });
    // Custom validation for checking if same kind of rule is already added
    // this.$validator.extend("checkIdenticalRules", {
    //   getMessage: field => "Two identical rules cannot be created.",
    //   validate: value => {
    //     console.log('in rule')
    //     for(let i = 0; i < this.skipRules.length-1;i++){
    //       if(this.skipRules[i].skipCondition === this.skipRules[this.skipRules.length - 1].skipCondition && this.skipRules[i].skipInclusion === this.skipRules[this.skipRules.length - 1].skipInclusion) {
    //         console.log('conditions matched')
    //         if(this.skipSelectedAns[i].sort().join(',')=== this.skipSelectedAns[this.skipRules.length - 1].sort().join(',')){
    //           return false;
    //         }
    //       }
    //     }
    //     return true;
    //   }
    // });
  },
  methods: {
    ...mapActions("editquestionEdit", [
      "createSkipLogicRules",
      "deleteSkipLogicRules",
      "setIsSkipLogic",
      "setFullScreenMode"
    ]),

    updateConnectionsArray() {
      this.questionLists.forEach((value, key) => {
        console.log(value);
        let qid = value.in_question_master_id ? value.in_question_master_id : value.dbQueId;
        console.log(this.surveyQuestionWithDetails[qid]);
        if(this.surveyQuestionWithDetails[qid]){

   this.questionLists[key]['in_question_type_id'] = this.surveyQuestionWithDetails[qid][Object.keys(this.surveyQuestionWithDetails[qid])[0]]['in_question_type_id'];
        }
        // Push skip logic data into array
        if (
          this.questionLists[key + 1] &&
          this.getSkipLogicDetails[qid] &&
          this.getSkipLogicDetails[qid].length > 0
        ) {
          this.$set(this.connectionsData, qid, []);

          this.getSkipLogicDetails[qid].forEach(
            (skipVal, vk) => {
              // skipVal["rules_array"].forEach((val, k) => {
              this.connectionsData[qid].push(
                "rule_" + qid + "_" + vk + "_if"
              );
              // this.connectionsData[qid].push(
              //   "rule_" + qid + "_" + vk + "_else"
              // );
              this.connectionsData[
                "rule_" + qid + "_" + vk + "_if"
              ] = [];
              this.connectionsData[
                "rule_" + qid + "_" + vk + "_else"
              ] = [];
              // push if question id on 0th index
              this.connectionsData[
                "rule_" + qid + "_" + vk + "_if"
              ].push(skipVal["in_then_question_id"]);
              // push else question id on 1st index
              this.connectionsData[
                "rule_" + qid + "_" + vk + "_else"
              ].push(skipVal["in_else_question_id"]);
              // });
            }
          );
        } else if (this.questionLists[key + 1]) {
          this.$set(this.connectionsData, qid, []);
          if(this.questionLists[key + 1]["in_question_master_id"]) {
            this.connectionsData[qid].push(this.questionLists[key + 1]["in_question_master_id"]);
            }
          else {
            this.connectionsData[qid].push(this.questionLists[key + 1]["dbQueId"]);
          }
        }
      });
      // Connection from start screen to first question
      if (this.questionLists[0] && this.questionStartEnd.start) {
        this.$set(
          this.connectionsData,
          this.questionStartEnd.start.in_question_master_id,
          []
        );
        if(this.questionLists[0]["in_question_master_id"]) {
        this.connectionsData[
          this.questionStartEnd.start.in_question_master_id
        ].push(this.questionLists[0]["in_question_master_id"]);
        }
        else {
         this.connectionsData[
          this.questionStartEnd.start.in_question_master_id
        ].push(this.questionLists[0]["dbQueId"]); 
        }
      }
      //Connection from last question to end screen
      if (this.questionLists.length > 0 && this.questionStartEnd.end && this.questionStartEnd.end.in_status) {
        let qid = this.questionLists[this.questionLists.length - 1][
            "in_question_master_id"
          ] ? this.questionLists[this.questionLists.length - 1][
            "in_question_master_id"
          ] : this.questionLists[this.questionLists.length - 1][
            "dbQueId"
          ]
        this.$set(
          this.connectionsData,
          qid,
          []
        );
        this.connectionsData[
          qid
        ].push(this.questionStartEnd.end.in_question_master_id);
      } else {
        if(this.questionLists[this.questionLists.length - 1]) {
          let qid = this.questionLists[this.questionLists.length - 1][
              "in_question_master_id"
            ] ? this.questionLists[this.questionLists.length - 1][
              "in_question_master_id"
            ] : this.questionLists[this.questionLists.length - 1][
              "dbQueId"
            ]
            console.log(this.questionLists[this.questionLists.length - 1])
            console.log(qid)
          this.$set(
            this.connectionsData,
            qid,
            []
          );
          this.connectionsData[
            qid
          ].push(-99);
        }
      }
      let lineno = 0;
      Object.keys(this.connectionsData).forEach(key => {
        let strt = document.querySelectorAll(
          "[data-que-id= " + "'" + key + "'" + "]"
        );
        let end = [];
        this.connectionsData[key].forEach(k => {
          end.push(
            document.querySelectorAll("[data-que-id= " + "'" + k + "'" + "]")
          );
        });

        if (strt.length > 0 && end.length > 0) {
          end.forEach(val => {
            if (strt[0] && val[0]) {
              let arrowFromLeft =
                Object.keys(this.connectionsData).filter(keyval => {
                  return key.includes("_0_")
                    ? keyval.includes(key.split("_0_")[0])
                    : key.includes("_1_")
                    ? keyval.includes(key.split("_1_")[0])
                    : keyval.includes("_2_")
                    ? keyval.includes(key.split("_2_")[0])
                    : "";
                }).length >= 4;
              this.linesInstance[lineno] = new LeaderLine(
                strt[0],
                val[0].getAttribute("data-que-id").includes("if")
                  ? LeaderLine.pointAnchor(val[0], {
                      x: val[0].parentElement.parentElement.offsetWidth / 2,
                      y: 0
                    })
                  : val[0],
                {
                  color: key.includes("if")
                    ? "#2c416e"
                    : key.includes("else")
                    ? "#34a474"
                    : "#f85",
                  size: 4,
                  startPlug: "disc",
                  startSocket: arrowFromLeft
                    ? key.includes("_0_")
                      ? key.includes("if")
                        ? "left"
                        : "bottom"
                      : key.includes("_1_")
                      ? key.includes("else")
                        ? "right"
                        : "bottom"
                      : "left"
                    : key.includes("if")
                    ? "left"
                    : key.includes("else")
                    ? "right"
                    : "bottom",
                  endSocket: arrowFromLeft
                    ? key.includes("_0_")
                      ? "left"
                      : key.includes("_1_")
                      ? "right"
                      : "left"
                    : key.includes("if")
                    ? "left"
                    : key.includes("else")
                    ? "right"
                    : "top",
                  // endSocket: (key.includes("if") || key.includes("else") && end.length === 1
                  //   ? "left"
                  //   : key.includes("if") || key.includes("else") && vk === 1
                  //   ? "right"
                  //   : "top",
                  // endSocket: key.includes("rule") ? "right" : "top",
                  path:
                    key.includes("if") || key.includes("else")
                      ? "grid"
                      : "straight",
                  startLabel:
                    key.includes("if") || key.includes("else")
                      ? val[0].getAttribute("data-qid")
                      : "",
                  endLabel:
                    key.includes("if") || key.includes("else")
                      ? strt[0].getAttribute("data-qid")
                      : "",
                  lineOffset: 100
                }
              );
              lineno++;
            }
          });
        }
      });
    },

    showRuleModal(evt, index) {
      this.skipRules = [];
      this.ruleAnsNoAns = [];
      this.ruleConditions = [];
      this.skipAnsArray = [];
      this.skipQueNextArray = [];
      this.skipQuePrevArray = [];
      this.skipIfSelectedQue = [];
      this.skipElseSelectedQue = [];
      this.skipSelectedAns = [];
      this.skipSelectedQue = [];
      this.isMultipleAnsAllowed = false;
      this.isQuestionTypeFace = false;
      this.isQuestionTypeStar = false;
      this.identicalRules = false;
      this.multipleAnsNotAllowedEqual = false;
      this.skipDataArray["in_question_master_id"] = this.questionLists[index].in_question_master_id ? this.questionLists[index].in_question_master_id : this.questionLists[index]['dbQueId'];
      this.questionTitle =
        this.questionLists[index].in_question_number +
        ". " +
        this.questionLists[index].st_question_title;
      if (
        evt.srcElement.id === "addLogicIcon" && (this.all.in_status !== constantCommonConfig.SURVEY_PUBLISHED || this.canEditRule)
      ) {
        this.isAddModal = true;
        this.skipRules.push({
          skipCondition: "EQUALS",
          skipInclusion: "ANY",
          isRuleNotAdded: true
        });
        this.ruleAnsNoAns = [false];

        this.$refs.skipLogicModal.show();
        // document.body.appendChild(this.$refs.skipLogicModal.$el);
        this.fillSkipAnswers(evt, index);
        // 2nd parameter -> 1: Add 2: Edit
        this.fillPrevNxtAns(index,1);
        this.$refs.skipLogicModal.show();
        this.errors.clear();
      } else if (
        evt.srcElement.id === "editRuleIcon" && (this.all.in_status !== constantCommonConfig.SURVEY_PUBLISHED || this.canEditRule)
      ) {
        this.isAddModal = false;
        this.$refs.skipLogicModal.show();
         this.errors.clear();
        // document.body.appendChild(this.$refs.skipLogicModal.$el);
        let editVal = [];
        editVal.in_question_master_id = evt.srcElement.getAttribute("ruleQid");

        editVal.in_rule_question_master_id = this.getSkipLogicDetails[
          editVal.in_question_master_id
        ][evt.srcElement.getAttribute("ruleNo")]["rules_array"][0][0][
          "in_question_master_id"
        ];

        this.editRuleId = this.getSkipLogicDetails[
          editVal.in_question_master_id
        ][evt.srcElement.getAttribute("ruleNo")]["in_skiplogic_master_id"];
        this.fillSkipAnswers(editVal, evt.srcElement.getAttribute("qNo"));
        this.fillPrevNxtAns((evt.srcElement.getAttribute("qNo")-1),2);

        let skipQid = this.getSkipLogicDetails[editVal.in_question_master_id][
          evt.srcElement.getAttribute("ruleNo")
        ]["rules_array"][0]
          ? this.getSkipLogicDetails[editVal.in_question_master_id][
              evt.srcElement.getAttribute("ruleNo")
            ]["rules_array"][0][0]["in_question_master_id"]
          : "";
        var selAns = this.skipQuePrevArray.filter(el => {
          return el.in_question_master_id === skipQid;
        });
        this.skipSelectedQue.push(selAns[0]);
        this.skipIfSelectedQue = this.skipQueNextArray.filter(el => {
          return (
            el.in_question_master_id ===
            this.getSkipLogicDetails[editVal.in_question_master_id][
              evt.srcElement.getAttribute("ruleNo")
            ]["in_then_question_id"]
          );
        })[0];
        this.skipElseSelectedQue = this.skipQueNextArray.filter(el => {
          return (
            el.in_question_master_id ===
            this.getSkipLogicDetails[editVal.in_question_master_id][
              evt.srcElement.getAttribute("ruleNo")
            ]["in_else_question_id"]
          );
        })[0];

        this.ruleAnsNoAns = this.getSkipLogicDetails[
          editVal.in_question_master_id
        ][evt.srcElement.getAttribute("ruleNo")]["st_skiplogic_ansnoans"].map(
          item => {
            if (item === "NOTANSWERED") return true;
            else if (item === "ANSWERED") return false;
          }
        );

        this.ruleConditions = this.getSkipLogicDetails[
          editVal.in_question_master_id
        ][evt.srcElement.getAttribute("ruleNo")][
          "st_skiplogic_condition"
        ].reduce((result, item) => {
          if (item === "OR") result.push(true);
          else if (item === "AND") result.push(false);
          return result;
        }, []);

        // if (empty(this.ruleConditions)) this.ruleConditions = [];
        // this.ruleConditions = this.getSkipLogicDetails[
        //   editVal.in_question_master_id
        // ][evt.srcElement.getAttribute("ruleNo")]["st_skiplogic_condition"];

        this.getSkipLogicDetails[editVal.in_question_master_id][
          evt.srcElement.getAttribute("ruleNo")
        ]["rules_array"].forEach((rule, ruleno) => {
          rule.forEach((ruledetails, ruledetno) => {
            if (ruledetno == 0) {
              this.skipRules.push({
                isRuleNotAdded: true,
                skipCondition:
                  ruledetails["st_logical_condition"] === "NA"
                    ? "EQUALS"
                    : ruledetails["st_logical_condition"],
                skipInclusion:
                  ruledetails["st_rule_type"] === "NA"
                    ? "ANY"
                    : ruledetails["st_rule_type"]
              });
            }
            if (!this.skipSelectedAns[ruleno]) {
              this.skipSelectedAns[ruleno] = [];
            }
            if (ruledetails["st_answer_value"] !== "NA")
              if (
                this.getSkipLogicDetails[editVal.in_question_master_id][
                  evt.srcElement.getAttribute("ruleNo")
                ]["in_question_type_id"] !== queTypeConfig.TYPE_MULTIPLE_IMAGE
              ) {
                this.skipSelectedAns[ruleno].push(
                  ruledetails["st_answer_value"]
                );
                // this.$set(
                //   this.skipSelectedAns[ruleno],
                //   this.skipSelectedAns[ruleno].length,
                //   ruledetails["st_answer_value"]
                // );
              } else {
                let setAns = {};
                this.skipAnsArray.forEach(obj => {
                  if (obj["img_path"] === ruledetails["st_answer_value"]) {
                    setAns = obj;
                  }
                });
                if (setAns) this.skipSelectedAns[ruleno].push(setAns);
              }
          });
        });
        // var selAns = this.skipQuePrevArray.filter(function(el) {
        //   return el.in_question_master_id === skipQid;
        // });
        // console.log(selAns);
        // this.skipSelectedQue.push([
        //   {
        //     in_question_master_id: skipQid,
        //     in_question_number: this.getSkipLogicDetails[
        //       editVal.in_question_master_id
        //     ][0]["in_question_number"],
        //     in_question_type_id: this.getSkipLogicDetails[
        //       editVal.in_question_master_id
        //     ][0]["in_question_type_id"]
        //   }
        // ]);

        this.$refs.skipLogicModal.show();
      } else if (
        evt.srcElement.id === "delRuleIcon" && (this.all.in_status !== constantCommonConfig.SURVEY_PUBLISHED || this.canEditRule)
      ) {
        this.$awn.confirm(
          "Are you sure you want to delete this question?",
          () => {
            this.skipDataArray["in_question_id"] = evt.srcElement.getAttribute(
              "ruleQid"
            );
            this.skipDataArray["in_skiplogic_master_id"] = this.getSkipLogicDetails[
              evt.srcElement.getAttribute("ruleQid")
            ][evt.srcElement.getAttribute("ruleNo")]["in_skiplogic_master_id"];
            this.deleteSkipLogicRules(this.skipDataArray);
            // var elem = document.querySelectorAll(".leader-line");
            // elem.forEach((leadline, lineno) => {
            //   leadline.parentNode.removeChild(leadline);
            // });
            this.linesInstance.forEach(line => {
              line.remove();
            }); 
        });
      }
      //console.log('Skip Rule ------',this.skipRules);
      if(this.isMultipleAnsAllowed){
         if(this.skipRules.some(rule => rule.skipCondition === "EQUALS")){
            console.log('Disable And')
            this.disableAndCondition = true;
         }   
      }
    },
    fillPrevNxtAns(index, addOrEdit) {
      // addOrEdit = 1 -> add
      // addOrEdit = 2 -> edit

      for (let i = 0; i < this.questionLists.length; i++) {
        console.log(index)
         let qid =  this.questionLists[i][
                "in_question_master_id"
              ] ?   this.questionLists[i][
                "in_question_master_id"
              ] :  this.questionLists[i][
                "dbQueId"
              ]
        if (i < index) {
          if (
            this.questionLists[i]["in_question_type_id"] !==
              queTypeConfig.TYPE_IMAGE &&
            this.questionLists[i]["in_question_type_id"] !==
              queTypeConfig.TYPE_DISPLAY && !(addOrEdit === 1 && this.ruleCreatedIds.includes(qid))
          ) {
            this.skipQuePrevArray.push({
              st_question_title:
                this.questionLists[i].in_question_number +
                ". " +
                this.questionLists[i]["st_question_title"],
              in_question_number: this.questionLists[i]["in_question_number"],
              in_question_type_id: this.questionLists[i]["in_question_type_id"],
             in_question_master_id: qid
            });
          }
        } else if (i == index) {
          if (
            this.questionLists[i]["in_question_type_id"] !==
              queTypeConfig.TYPE_IMAGE &&
            this.questionLists[i]["in_question_type_id"] !==
              queTypeConfig.TYPE_DISPLAY && !(addOrEdit === 1 && this.ruleCreatedIds.includes(qid))
          ) {
            this.skipQuePrevArray.push({
              st_question_title:
                this.questionLists[i].in_question_number +
                ". " +
                this.questionLists[i]["st_question_title"],
              in_question_number: this.questionLists[i]["in_question_number"],
              in_question_type_id: this.questionLists[i]["in_question_type_id"],
             in_question_master_id: qid
            });
            if(addOrEdit === 1) {
              this.skipSelectedQue.push({
                st_question_title:
                  this.questionLists[i].in_question_number +
                  ". " +
                  this.questionLists[i]["st_question_title"],
                in_question_number: this.questionLists[i]["in_question_number"],
                in_question_type_id: this.questionLists[i]["in_question_type_id"],
              in_question_master_id: qid
              });
            }
          }
          this.skipQueNextArray.push({
            st_question_title:
              this.questionLists[i].in_question_number +
              ". " +
              this.questionLists[i]["st_question_title"],
            in_question_number: this.questionLists[i]["in_question_number"],
            in_question_master_id: qid
          });
        } else {
          this.skipQueNextArray.push({
            st_question_title:
              this.questionLists[i].in_question_number +
              ". " +
              this.questionLists[i]["st_question_title"],
            in_question_number: this.questionLists[i]["in_question_number"],
            in_question_master_id: qid
          });
        }
      }
      if (
        this.questionStartEnd["end"] &&
        this.questionStartEnd["end"]["in_question_number"] &&
        this.questionStartEnd["end"]["in_status"]
      ) {
        this.skipQueNextArray.push({
          st_question_title: "End Screen",
          in_question_number: this.questionStartEnd["end"][
            "in_question_number"
          ],
          in_question_master_id: this.questionStartEnd["end"][
            "in_question_master_id"
          ]
        });
      } else {
        this.skipQueNextArray.push({
          st_question_title: "End Form",
          in_question_number: -99,
          in_question_master_id: -99
        });
      }
    },
    hideSkipModal() {
      this.errors.clear();
      this.$refs.skipLogicModal.hide();
    },
    addRule() {
      this.$validator.validateAll().then(() => {
        if (this.errors.items.length === 0) {
          // Check if same kind of rule being added twice
          this.identicalRules = false;
          this.multipleAnsNotAllowedEqual = false;
          for(let i = 0; i < this.skipRules.length-1;i++){       
          
          if(this.skipRules[i].skipCondition === this.skipRules[this.skipRules.length - 1].skipCondition && this.skipRules[i].skipInclusion === this.skipRules[this.skipRules.length - 1].skipInclusion) {
            if(this.skipSelectedAns[i].length === 0 && !this.skipSelectedAns[this.skipRules.length - 1]) {
               this.identicalRules=true;
            }
            else if(this.skipSelectedAns[i] && this.skipSelectedAns[this.skipRules.length - 1]) {
              if(this.skipSelectedAns[i].sort().join(',') === this.skipSelectedAns[this.skipRules.length - 1].sort().join(',')) {
                this.identicalRules=true;
              }
            }
          }
        }

        console.log('Skip Rules --',this.skipRules);
         if(this.isMultipleAnsAllowed && this.skipRules.length > 1){
            if(this.skipRules.some(rule => rule.skipCondition === "EQUALS")){
               console.log('EQUALS AVAILABLE',this.ruleConditions);
               if(this.ruleConditions.indexOf(true)){
                  console.log('And AVAILABLE');
                  this.multipleAnsNotAllowedEqual = true;
                  return false;
               }               
            }   
         }

        

          if(!this.identicalRules){
          this.skipDataArray.in_skiplogic_master_id = this.isAddModal
            ? ""
            : this.editRuleId;
          this.skipDataArray.in_then_question_id = this.skipIfSelectedQue.in_question_master_id;
          this.skipDataArray.in_then_question_number = this.skipIfSelectedQue.in_question_number;
          this.skipDataArray.in_else_question_id = this.skipElseSelectedQue.in_question_master_id;
          this.skipDataArray.in_else_question_number = this.skipElseSelectedQue.in_question_number;
          this.skipDataArray.in_question_number = this.skipSelectedQue[0].in_question_number;

          // Convert boolean values to AND/OR

          let ruleconds = this.ruleConditions.reduce((result, item) => {
            if (item === true) result.push("OR");
            else if (item === false) result.push("AND");
            return result;
          }, []);


          // let ruleconds = this.ruleConditions.map(item => {
          //   if (item === true) return "OR";
          //   else if (item === false) return "AND";
          // });
          // if (empty(ruleconds)) ruleconds = [];
          this.skipDataArray.st_skiplogic_condition = ruleconds
          let ansnoans = this.ruleAnsNoAns.map(item => {
            if (item === true) return "NOTANSWERED";
            else if (item === false) return "ANSWERED";
          });
          this.skipDataArray.ans_noans_array = ansnoans;
          this.skipDataArray.rules_array = [];
          this.skipDataArray.qtype_array = [];
          Object.keys(this.skipRules).forEach(key => {
            this.skipDataArray.rules_array[key] = [];
            this.skipDataArray.qtype_array.push(
              this.skipSelectedQue[0].in_question_type_id
            );
            // For pushing rule details when NotAnswered is choosen
            if (
              ansnoans[key] == "NOTANSWERED" ||
              this.notAnsNoAnsQue === false
            ) {
              this.skipDataArray.rules_array[key].push({
                in_question_master_id: this.skipSelectedQue[0]
                  .in_question_master_id,
                st_answer_value: "NA",
                st_logical_condition: "NA",
                st_rule_type: "NA"
              });
            } else {
              Object.keys(this.skipSelectedAns[key]).forEach(k => {
                // let log_cond = this.skipRules[key].skipCondition
                //   ? this.skipRules[key].skipConditionContains
                //     ? 1
                //     : 2
                //   : this.skipRules[key].skipConditionContains
                //   ? 3
                //   : 4;
                // console.log(log_cond);
                this.skipDataArray.rules_array[key].push({
                  in_question_master_id: this.skipSelectedQue[0]
                    .in_question_master_id,
                  st_answer_value: this.skipSelectedAns[key][k]["img_path"]
                    ? this.skipSelectedAns[key][k]["img_path"]
                    : this.skipSelectedAns[key][k],
                  st_logical_condition: this.skipRules[key].skipCondition,
                  st_rule_type: this.skipRules[key].skipInclusion
                });
              });
            }
          });

          this.hideSkipModal();
          this.createSkipLogicRules(this.skipDataArray).then(value => {});
          this.linesInstance.forEach(line => {
            line.remove();
          });
          // var elem = document.querySelectorAll(".leader-line");
          // elem.forEach((leadline, lineno) => {
          //   leadline.parentNode.removeChild(leadline);
          // });
          }
        }
      });
    },
    fillSkipAnswers(val, id) {
      this.skipAnsArray = [];
      // Disable Inclusion ALL
      this.isMultipleAnsAllowed = false;
      this.isQuestionTypeFace = false;
      this.isQuestionTypeStar = false;
      // Set inclusion to any
      // this.skipRules[0].skipInclusion = "ANY";
      // Clear selected answer choices
      this.skipSelectedAns[0] = [];
      let qid = "";
      if (val.in_rule_question_master_id) qid = val.in_rule_question_master_id;
      else if (val.in_question_master_id) qid = val.in_question_master_id;
      else qid = val.currentTarget.firstChild.getAttribute("data-que-id");
      // Pushing selected question's answer values in the dropdown for skiplogic for list
      if (
        this.surveyQuestionWithDetails[qid]["qval_6"] &&
        this.surveyQuestionWithDetails[qid]["qval_6"]["in_question_type_id"] ===
          queTypeConfig.TYPE_LIST
      ) {
        this.notAnsNoAnsQue = true;
        let ansVal = this.surveyQuestionWithDetails[qid]["qval_6"][
          "st_answer_text"
        ].split("\n");
        this.pushAnswers(ansVal);
        // For adding other option in answers list
        if (this.surveyQuestionWithDetails[qid]["qval_13"]["st_answer_text"]) {
          this.pushAnswers(["Other (Not from list)"]);
        }
      }
      // Pushing selected question's answer values in the dropdown for skiplogic for multiple choice text
      else if (
        this.surveyQuestionWithDetails[qid]["qval_14"] &&
        this.surveyQuestionWithDetails[qid]["qval_14"][
          "in_question_type_id"
        ] === queTypeConfig.TYPE_MULTIPLE_TEXT
      ) {
        this.notAnsNoAnsQue = true;
        if (
          this.surveyQuestionWithDetails[qid][
            queValidationConfig.VALIDATION_ALLOW_MORE_THAN_ONE_ANS
          ]["st_answer_text"]
        ) {
          this.isMultipleAnsAllowed = true;  
        }
        let ansVal = this.surveyQuestionWithDetails[qid]["qval_14"][
          "st_answer_text"
        ].split("\n");
        this.pushAnswers(ansVal);
        // For adding other option in answers list
        if (this.surveyQuestionWithDetails[qid]["qval_13"]["st_answer_text"]) {
          this.pushAnswers(["Other (Not from list)"]);
        }
      }
      // Pushing selected question's answer values in the dropdown for skiplogic for two choices yes/no
      else if (
        this.surveyQuestionWithDetails[qid]["qval_16"] &&
        this.surveyQuestionWithDetails[qid]["qval_16"][
          "in_question_type_id"
        ] === queTypeConfig.TYPE_YES_NO
      ) {
        this.notAnsNoAnsQue = true;
        let ansVal = this.surveyQuestionWithDetails[qid]["qval_16"][
          "st_answer_text"
        ].split("\n");
        this.pushAnswers(ansVal);
      }
      // Pushing selected question's answer values in the dropdown for skiplogic for two choices true/false
      else if (
        this.surveyQuestionWithDetails[qid]["qval_17"] &&
        this.surveyQuestionWithDetails[qid]["qval_17"][
          "in_question_type_id"
        ] === queTypeConfig.TYPE_TRUE_FALSE
      ) {
        this.notAnsNoAnsQue = true;
        let ansVal = this.surveyQuestionWithDetails[qid]["qval_17"][
          "st_answer_text"
        ].split("\n");
        this.pushAnswers(ansVal);
      }
      // Pushing selected question's answer values in the dropdown for skiplogic for two choices others
      else if (
        this.surveyQuestionWithDetails[qid]["qval_40"] &&
        this.surveyQuestionWithDetails[qid]["qval_40"][
          "in_question_type_id"
        ] === queTypeConfig.TYPE_OTHER
      ) {
        this.notAnsNoAnsQue = true;
        let ansVal = [];
        ansVal.push(
          this.surveyQuestionWithDetails[qid]["qval_40"]["st_answer_text"]
        );
        ansVal.push(
          this.surveyQuestionWithDetails[qid]["qval_41"]["st_answer_text"]
        );
        this.pushAnswers(ansVal);
      }
      // Pushing selected question's answer values in the dropdown for skiplogic for terms and conditions
      else if (
        this.surveyQuestionWithDetails[qid]["qval_19"] &&
        this.surveyQuestionWithDetails[qid]["qval_19"][
          "in_question_type_id"
        ] === queTypeConfig.TYPE_TERMS_AND_CONDITIONS
      ) {
        this.notAnsNoAnsQue = true;
        let ansVal = this.surveyQuestionWithDetails[qid]["qval_19"][
          "st_answer_text"
        ].split("\n");
        if (ansVal.length > 1) this.pushAnswers(ansVal);
        else {
          this.notAnsNoAnsQue = false;
        }
      }
      // Pushing selected question's answer values in the dropdown for skiplogic for face rating
      else if (
        this.surveyQuestionWithDetails[qid]["qval_39"] &&
        this.surveyQuestionWithDetails[qid]["qval_39"][
          "in_question_type_id"
        ] === queTypeConfig.TYPE_SATISFACTION
      ) {
        this.notAnsNoAnsQue = true;
        this.isQuestionTypeFace = true;
        let ansVal = this.surveyQuestionWithDetails[qid]["qval_39"][
          "st_answer_text"
        ].split("sep");
        this.pushAnswers(ansVal);
      }
      // Pushing selected question's answer values in the dropdown for skiplogic for star rating
      else if (
        this.surveyQuestionWithDetails[qid]["qval_38"] &&
        this.surveyQuestionWithDetails[qid]["qval_38"][
          "in_question_type_id"
        ] === queTypeConfig.TYPE_STAR
      ) {
        this.notAnsNoAnsQue = true;
        this.isQuestionTypeStar = true;
        let ansVal = [];
        for (
          var i = 1;
          i <= this.surveyQuestionWithDetails[qid]["qval_38"]["st_answer_text"];
          i++
        ) {
          ansVal.push(i.toString());
        }
        this.pushAnswers(ansVal);
      }
      // Pushing selected question's answer values in the dropdown for skiplogic for multiple choice image
      else if (
        this.surveyQuestionWithDetails[qid]["qval_15"] &&
        this.surveyQuestionWithDetails[qid]["qval_15"][
          "in_question_type_id"
        ] === queTypeConfig.TYPE_MULTIPLE_IMAGE
      ) {
        this.notAnsNoAnsQue = true;
        if (
          this.surveyQuestionWithDetails[qid][
            queValidationConfig.VALIDATION_ALLOW_MORE_THAN_ONE_ANS
          ]["st_answer_text"]
        ) {
          this.isMultipleAnsAllowed = true;
        }
        let ansVal = [];
        this.surveyQuestionWithDetails[qid]["qval_15"][
          "st_answer_details"
        ].forEach((value, valIndex) => {
          ansVal.push({
            img_label: this.surveyQuestionWithDetails[qid]["qval_15"][
              "st_answer_label_details"
            ][valIndex]
              ? this.surveyQuestionWithDetails[qid]["qval_15"][
                  "st_answer_label_details"
                ][valIndex]
              : "",
            img_url: value,
            img_path: this.surveyQuestionWithDetails[qid]["qval_15"][
              "st_answer_path_details"
            ][valIndex],
            img_id: valIndex
          });
        });
        this.pushAnswers(ansVal);
        // For adding other option in answers list
        if (this.surveyQuestionWithDetails[qid]["qval_13"]["st_answer_text"]) {
          this.pushAnswers([
            {
              img_label: "Other (Not from list)",
              img_url: other_image,
              img_path: other_image,
              img_id: this.surveyQuestionWithDetails[qid]["qval_15"][
                "st_answer_label_details"
              ].length
            }
          ]);
        }
      } else {
        this.notAnsNoAnsQue = false;
      }
    },
    pushAnswers(ansValues) {
      ansValues.forEach(value => {
        this.skipAnsArray.push(value);
      });
    },
    addRuleToArray(ind) {
      if (document.getElementsByName("selectedAnswer").length > 0) {
        this.$validator.validate('selectedQuestion')
        this.$validator.validate('selectedAnswer').then(() => {
        
        if (this.errors.items.length === 0) {
          this.$set(this.skipRules[ind], "isRuleNotAdded", false);
          if (this.ruleAnsNoAns[ind]) {
            this.skipSelectedAns[ind] = [];
          }
        }
        });
      } else {
        this.$set(this.skipRules[ind], "isRuleNotAdded", false);
        if (this.ruleAnsNoAns[ind]) {
          this.skipSelectedAns[ind] = [];
        }
      }
      //console.log(this.isMultipleAnsAllowed,'QUestion Type --- Add Rule--',this.skipRules);
      if(this.isMultipleAnsAllowed){
         if(this.skipRules.some(rule => rule.skipCondition === "EQUALS")){
            console.log('Disable And')
            this.disableAndCondition = true;
         }else{
            this.disableAndCondition = false;
         }   
      }
      
    },
    removeRuleFromArray(ind) {
      this.identicalRules = false;
      this.skipSelectedAns.splice(ind, 1);
      this.ruleAnsNoAns.splice(ind, 1);
      if (ind >= this.ruleConditions.length)
        this.ruleConditions.splice(ind - 1, 1);
      else this.ruleConditions.splice(ind, 1);
      this.skipRules.splice(ind, 1);
      //console.log('Delete Rule --',this.isMultipleAnsAllowed,'-----------',this.disableAndCondition)
      setTimeout(() => {
         if(this.isMultipleAnsAllowed){
                  if(this.skipRules.some(rule => rule.skipCondition === "EQUALS")){
                     console.log('Disable And')
                     this.disableAndCondition = true;
                  }else{
                     this.disableAndCondition = false;
                  }
               }
      },1000);   
      
    },
    addNewRule() {
      this.skipRules.push({
        skipCondition: "EQUALS",
        skipInclusion: "ANY",
        isRuleNotAdded: true
      });
      if (!this.isMultipleAnsAllowed) {
        this.ruleConditions.push(true);
      } 
      /*else if(this.isMultipleAnsAllowed && this.disableAndCondition) {
         this.ruleAnsNoAns[this.ruleAnsNoAns.length - 1]
          ? this.ruleConditions.push(true)
          : this.ruleConditions.push(true);
      }*/
       else {
         console.log('else---------');
        this.ruleAnsNoAns[this.ruleAnsNoAns.length - 1]
          ? this.ruleConditions.push(false)
          : this.ruleConditions.push(true);
      }
      this.ruleAnsNoAns.push(false);
    },
    removeOptionFromSelect(i, evt) {
      // For removing face rating answers
      if (isNaN(evt.srcElement.id)) {
        let ansVals = this.skipSelectedAns[i];

        if (evt.srcElement.id.indexOf("star") > -1) {
          let index = ansVals.indexOf(evt.srcElement.id.split("star")[1]);
          if (index > -1) {
            ansVals.splice(index, 1);
          }
        } else {
          let index = ansVals.indexOf(evt.srcElement.id);
          if (index > -1) {
            ansVals.splice(index, 1);
          }
        }

        this.$set(this.skipSelectedAns, i, ansVals);
        this.skipSelectedAns[i] = Object.assign([], ansVals);
      }
      // for multiple choice image remove
      else {
        let ansVals = this.skipSelectedAns[i].filter(function(obj) {
          return obj.img_id != evt.srcElement.id;
        });
        this.$set(this.skipSelectedAns, i, ansVals);
      }
    },
    updateSkipLogic() {
      // var elem = document.querySelectorAll(".leader-line");
      // elem.forEach((leadline, lineno) => {
      //   leadline.parentNode.removeChild(leadline);
      // });
      this.linesInstance.forEach(line => {
        line.remove();
      });
      let val = {};
      val.skipLogic = false;
      val.qno = this.currentQno;
      this.setIsSkipLogic(val);
      document.body.classList.remove("skip-logic-section");
    },
    callSetFullScreenMode(val){
      this.setFullScreenMode(val)
      setTimeout(() => {
        this.linesInstance.forEach(line => {
        line.position()
      })
      },100);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/skipLogic.vue